// extracted by mini-css-extract-plugin
module.exports = {"circle":"SaaSTierIcon_circle__WQsUJ"};